/**
 * Storage keys
 */
export const STORAGE_KEYS = {
  CART: "fs_cart",
  EVENT_QUEUE: "fs_event_queue",
  SESSION: "fs_session",
  FINGERPRINT: "fs_fingerprint",
  COUNTRY: "fs_country",
  LOCALE: "fs_locale",
  SETTINGS: "fs_settings",
};
